import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const queryParams = Object.fromEntries(searchParams.entries());
    return (
      <Component
        {...props}
        router={{
          location,
          navigate,
          params,
          searchParams,
          setSearchParams,
          queryParams,
        }}
      />
    );
  }

  return ComponentWithRouterProp;
}
